import { motion } from "framer-motion";
import {
  PackageSearch,
  Handshake,
  Beaker,
  Atom,
  Bug,
  Thermometer,
  ShieldCheck,
  GraduationCap,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/lib/site";

const ICONS = {
  PackageSearch,
  Handshake,
  Beaker,
  Atom,
  Bug,
  Thermometer,
  ShieldCheck,
  GraduationCap,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-slate-50 py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-4">What We Do</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Eight disciplines. One integrated pharma services partner.
            </h2>
          </div>
          <p className="lg:col-span-5 text-slate-600 text-base leading-relaxed lg:text-right">
            Every engagement is delivered by pharmacists, chemists, quality auditors and regulatory experts with deep
            hands-on regulated-industry experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || PackageSearch;
            return (
              <motion.a
                key={s.id}
                href="#contact"
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
                className="group relative flex flex-col bg-white border border-slate-200 hover:border-teal-500 hover:shadow-xl transition-all duration-300 p-7"
              >
                <div className="flex items-start justify-between gap-4">
                  <span className="inline-flex items-center justify-center w-12 h-12 bg-teal-50 text-teal-700 border border-teal-100 group-hover:bg-teal-700 group-hover:text-white transition-colors">
                    <Icon className="w-6 h-6" strokeWidth={1.5} />
                  </span>
                  <ArrowUpRight
                    className="w-5 h-5 text-slate-300 group-hover:text-teal-700 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                    strokeWidth={1.75}
                  />
                </div>

                <h3 className="mt-6 font-display text-lg font-semibold text-slate-900 leading-snug group-hover:text-teal-700 transition-colors">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.short}</p>

                <ul className="mt-5 space-y-2 pt-5 border-t border-slate-100">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-xs text-slate-700 leading-relaxed">
                      <span className="mt-1.5 w-1 h-1 bg-teal-600 shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
